<template>
  <div
    class="mask"
    :style="positionStyle"
    :class="[fullScreen?'mask-global':'mask-local']"
    v-show="visible"
  >
    <transition name="slide-fade">
      <div class="content" :class="['size-'+size]" v-show="visible">
        <div class="icon-loading" v-if="type==='loading'">
          <span class="icon-loading-item"></span>
          <span class="icon-loading-item"></span>
          <span class="icon-loading-item"></span>
        </div>
        <div class="icon-warning" v-if="type==='warning'"></div>
        <p class="text">{{message}}</p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {

  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: 'default'
    },
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    fullScreen: {
      type: Boolean,
      required: false,
      default: false
    },
    position: {
      required: false,
      validator(val) {
        return ['top center', 'bottom center'].indexOf(val) !== -1
      }
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    positionStyle() {
      if (this.position === 'top center') {
        return {
          top: '128px'
        }
      }
      return {}
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
  },
  components: {

  }
}

</script>

<style lang="less" scoped>
div.mask {
  position: fixed;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  &.mask-global {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  &.mask-local {
    width: 80%;
    height: 32px;
    left: 10%;
    top: calc(50% - 16px);
  }
  .content {
    background: rgba(0, 0, 0, 0.7);
    border-radius: 10px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    display: inline-block;
    max-width: 100%;
    text-align: center;
    &.size-large {
      padding: 52px 20px 42px;
      width: 240px;
      height: 240px;
      box-sizing: border-box;
    }
    &.size-medium {
      padding: 20px 36px;
    }
    .text {
      font-size: 28px;
      line-height: 32px;
      color: #ffffff;
      padding: 18px 0;
      margin: 0;
      z-index: 1;
    }
  }
  .slide-fade-enter-active {
    transition: all 2s cubic-bezier(0, 2.3, 0.8, 1);
  }
  .slide-fade-leave-active {
    transition: all 0.8s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    opacity: 0;
  }
  // css-icon
  .icon-loading {
    text-align: center;
    padding: 18px 0;
    .icon-loading-item {
      display: inline-block;
      width: 12px;
      height: 22px;
      background: #ffffff;
      transform: skewX(-30deg);
      margin-right: 10px;
      animation: lds-grid 1.2s linear infinite;
      &:nth-child(1) {
        animation-delay: -0.8s;
      }
      &:nth-child(2) {
        animation-delay: -0.4s;
      }
      &:nth-child(3) {
        animation-delay: 0s;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .icon-warning {
    width: 100%;
    height: 72px;
    background-image: url("./assets/icon-warn-large.png");
    background-size: 72px;
    background-position: center;
    background-repeat: no-repeat;
  }
}
@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  25% {
    opacity: 0.37;
  }
  75% {
    opacity: 0.07;
  }
}
</style>
